import * as React from 'react';

import MapboxRasterLayer from './MapboxRasterLayer';
import MapboxVectorLayer from './MapboxVectorLayer';

import * as projections from '../../../../projections';

const LayersForSurvey = ({ map, surveyId, layers }) => {
  const layersForSurvey = projections.layersForSurvey(surveyId, layers).reverse();
  return (
    <LayerSet map={map} layers={layersForSurvey} />
  );
};

const LayerSet = ({ map, layers }) => {
  return (
    <>
    {layers.map(layer => {
      // TODO: See if `<VectorLayer>` component is necessary, or if `RasterLayer` component should be parameterizable (and renamed)
      if (layer.type === 'mapbox_raster') {
        return <MapboxRasterLayer key={layer.id} map={map} layer={layer}  />;
      } else if (layer.type === 'mapbox_vector') {
        return <MapboxVectorLayer key={layer.id} map={map} layer={layer} />;
      } else if (layer.type === 'annotation') {
        2+2; // Just chill;
      } else {
        console.error(`Tried to render layer with type <<${layer.type}>> but found no appropriate component.`);
      }
    })}
    </>
  );
};

export default LayersForSurvey;
